"use client";
import React from "react";
import {
  SliderWrapper,
  TokenBox,
  TokenCardSilderArrows,
  TokenCardSilderWrapper
} from "./style";
import { Button } from "app/_components/components/Button";
import { Heading } from "app/_components/components/Text/Heading";
import { TrendingTokenCardComponent } from "components/parts/TrendingTokenCard";
import { getIcon } from "utils/currencies/icon";
import type { TrendingCoinObj } from "types/howToBuy-type";
import { IconChevronLeftSmall, IconChevronRightSmall } from "@hubble/icons";
import { Colors } from "themes/color-palette";
import { DIRECTION, useHorizontalScroll } from "hooks/useHorizontalScroll";

interface TokenCardSliderProps {
  title: string;
  coinsArray: Array<TrendingCoinObj>;
}
const TokenCardSlider = (props: TokenCardSliderProps) => {
  const { title, coinsArray } = props;

  const { ref, handleClick, handleScroll, isBackDisabled, isNextDisabled } =
    useHorizontalScroll(128, 16, 3);

  const generateTokenCards = (): Array<any> => {
    return coinsArray?.map((trendingCoin: TrendingCoinObj) => {
      return (
        <TrendingTokenCardComponent
          key={trendingCoin.name}
          slug={trendingCoin.slug}
          coinSymbol={trendingCoin.coin}
          coinChange={parseFloat(trendingCoin["24hrPercentDelta"])}
          coinPrice={trendingCoin.ask}
          coinImgUrl={getIcon(trendingCoin?.coin?.toLowerCase(), "circle")}
          cardStyles={{
            borderRadius: "20px",
            border: "1px solid transparent",
            background: Colors.gray[50],
            padding: "1rem"
          }}
        />
      );
    });
  };

  const handleNextSlide = () => {
    handleClick(DIRECTION.next);
  };

  const handlePrevSlide = () => {
    handleClick(DIRECTION.back);
  };

  if (!Array.isArray(coinsArray) || coinsArray.length === 0) {
    return null;
  }

  return (
    <TokenCardSilderWrapper>
      <TokenBox style={{ padding: "0px 0px 16px 0px" }}>
        <Heading
          size="md"
          className="tablet:!text-[24px] tablet:!leading-[28px] tablet:!tracking-[-0.5px] tablet:!font-medium !text-[18px] !leading-[24px] !font-medium !tracking-[-0.25px]"
          style={{ display: "flex", alignItems: "center" }}
        >
          {title}
        </Heading>
        <TokenCardSilderArrows justifyContent="center" alignItems="center">
          <Button
            variant="tertiary"
            onClick={handlePrevSlide}
            disabled={isBackDisabled}
            className="!bg-transparent"
          >
            <IconChevronLeftSmall />
          </Button>
          <Button
            variant="tertiary"
            onClick={handleNextSlide}
            disabled={isNextDisabled}
            className="!bg-transparent"
          >
            <IconChevronRightSmall />
          </Button>
        </TokenCardSilderArrows>
      </TokenBox>
      <SliderWrapper ref={ref} onScroll={handleScroll}>
        {generateTokenCards()}
      </SliderWrapper>
    </TokenCardSilderWrapper>
  );
};

export default TokenCardSlider;
